import { instance } from './setup'

export default {
  getGrades () {
    return instance.get('/sections/level/1')
  },

  addGrade (gradeDetail) {
    return instance.post('/sections', gradeDetail)
  },

  updateGrade (id, gradeDetail) {
    return instance.put(`/sections/${id}`, gradeDetail)
  }
}
